import type { CollectionSummaryJSONObject } from '@ikegps/core-api';
import { ModalFormComponent, type ModalFormComponentCtx } from '../../components/modal.form/modal.form.component';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { CollectionStatusModalCtrl } from './collection.status.modal.ctrl';
import { CSS, Style } from './collection.status.modal.style';
import { StatusSelector } from './status.selector';

addStyles(Style);

export class CollectionStatusModal extends ModalFormComponent {
	private ctrl: CollectionStatusModalCtrl;
	public statusSelector: StatusSelector;

	constructor(ctx: ModalFormComponentCtx, collections: CollectionSummaryJSONObject[]) {
		super(ctx);
		this.ctrl = new CollectionStatusModalCtrl(collections);
		this.statusSelector = new StatusSelector();
		this.addState(this.statusSelector.inputState);
	}

	get nodes(): MithrilVNode {
		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.content }, [
				m('p', Translate(T.COLLECTION_STATUS_CONFIRM, { count: this.ctrl.collections.length })),
				this.statusSelector.view(),
			]),
			m('div', { className: CSS.contentSecond }, [this.viewStats(), this.statusSelector.selectedStats()]),
		]);
	}

	private viewStats(): MithrilVNode {
		const actualStatuses = this.ctrl.getActualStatuses();
		return m(
			'ul',
			{ className: CSS.list },
			Object.keys(actualStatuses).map(function (key) {
				const statusText = key === 'undefined' ? 'No status' : key;
				return m('li', statusText + ': ' + actualStatuses[key]);
			})
		);
	}

	override async submit() {
		await this.ctrl.SetStatusCollections(this.statusSelector.selectedStatus, this.statusSelector.ctrl.allStatuses);
	}
}
